<template>
    <div class="cash acccont">
        <div class="acctit">
            <div @click="returnpage" class="returnbtn" v-if="isApp"><i class="el-icon-arrow-left"></i></div>
            <div :class="[!isApp?'flexbox fle-sb': '']">
              {{$t('account.withdrawal')}}
              <div v-if="!isApp && nextWithdrawalTime">{{$t('account.withdrawal_left')}} {{countDownTime}}</div>
            </div>
        </div>

        <div class="canbos">
            <div v-if="isApp">
                <div class="flexbox lctitbox">
                    <img src="../../assets/imgs/qd.png">
                    <div class="texal">
                        <div class="colory fontw">{{user.money}}<span class="minim"> ≈ ${{user.money}}</span></div>
                        <div>{{$t('account.balance')}}(USDT)</div>
                        <div class="colory fontw posrbtn" v-if="!user.user_id" @click="$router.push({path: '/login'})">
                            {{$t('account.login')}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="texac">
                <div class="formbox">
                    <div class="accctit" v-if="!isApp">
                        <div>{{$t('account.withdrawal')}}</div>
                    </div>
                    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px">
                        <el-form-item :label="$t('account.wallet2')" prop="walletAddress">
                            <div v-if="isApp && nextWithdrawalTime" class="nextcash">{{$t('account.withdrawal_left')}} {{countDownTime}}</div>
                            <el-select v-model="ruleForm.walletAddress" class="selebox"
                                       :placeholder="$t('account.select_wallet')">
                                <i slot="prefix" class="el-input__icon el-icon-postcard"></i>
                                <el-option v-for="item in walletList" :key="item.value" :label="item.label"
                                           :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="$t('account.amount')" prop="money">
                            <el-input prefix-icon="el-icon-money" type="number" v-model="ruleForm.money"
                                      :placeholder="$t('account.input_withdrawal_amount')"
                                      autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('account.trader_password')" prop="payPassword">
                            <el-input prefix-icon="el-icon-key" type="password" v-model="ruleForm.payPassword"
                                      :placeholder="$t('account.input_trader_password')"
                                      autocomplete="off"></el-input>
                        </el-form-item>
                        <div class="btnn bgb texac" @click="submitForm('ruleForm')">{{$t('account.confirm')}}</div>
                    </el-form>
                </div>
            </div>
            <div class="texac">
                <div class="accctit">
                    {{$t('account.withdrawal_record')}}
                </div>
                <div class="sylistbox">
                    <div class="tablet flexbox">
                        <div>{{$t('account.withdrawal_amount')}}</div>
                        <div>{{$t('account.withdrawal_status')}}</div>
                        <div>{{$t('account.withdrawal_date')}}</div>
                    </div>
                    <div class="srollbox">
                        <div class="tablet itemvue flexbox" v-for="(item, index) in list" :key="index">
                            <div>{{item.amount}}</div>
                            <div>{{item.status_text}}</div>
                            <div>{{item.createtime2}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import {
        do_withdraw, getWithdrawList
    } from '@/api/withdraw.js'

    export default {
        name: 'caSh',
        data() {
            var checkMoney = (rule, value, callback) => {

                let message = ""
                if (value.trim() == "") {
                    //this.$message.error('邮箱不能为空');
                    message = this.$t('account.input_withdrawal_amount');
                    callback(new Error(message))
                } else if (Number(value) < 0) {
                    message = this.$t('account.input_right_withdrawal_amount');
                    callback(new Error(message))
                } else {
                    callback();
                }
            };
            var validateWalletAddress = (rule, value, callback) => {

                if (value == "") {
                    //this.$message.error('请输入密码')
                    let message = this.$t('account.select_wallet_address')
                    callback(new Error(message))
                } else {
                    callback()
                }
            };
            var validatePayPass = (rule, value, callback) => {
                if (value.trim() == "") {
                    //this.$message.error('请输入密码')
                    let message = this.$t('account.input_your_trader_password')
                    callback(new Error(message));
                } else {
                    callback();
                }
            };
            return {
                ruleForm: {
                    money: '',
                    walletAddress: '',
                    payPassword: ''
                },
                classOption: {
                    step: 0.5
                },
                user: {
                    user_id: -1,
                    money: '0.00',
                },
                list: [],
                walletList: [],
                nextWithdrawalTime: '',
                countDownTime: '',
                countDownFn: null,
                rules: {
                    money: [{
                        validator: checkMoney,
                        trigger: "blur"
                    }],

                    walletAddress: [{
                        validator: validateWalletAddress,
                        trigger: "blur"
                    }],
                    payPassword: [{
                        validator: validatePayPass,
                        trigger: "blur"
                    }]
                }
            }

        },
        computed: {
            isApp() {
                return document.documentElement.clientWidth < 800 ? true : false
            },
            routeName() {
                console.log(this.$route.path)
                return this.$route.path
            }
        },
        mounted() {
            this.getList();
        },
        destroyed(){
            clearInterval(this.countDownFn); //清除定时器
        },
        methods: {
            getList() {
                getWithdrawList().then(res => {
                    if (res.code == 1) {
                        this.user = res.data.user
                        this.list = res.data.list
                        this.walletList = res.data.walletList
                        this.countDownTime = ""
                        this.nextWithdrawalTime = res.data.nextWithdrawalTime
                        if(this.nextWithdrawalTime){
                            this.countDown()
                        }
                    }
                }).catch(_ => {

                });
            },
            countDownFun(time) {
                // console.log(time)
                let startTime = new Date(); //当前时间
                let end = new Date(time); //结束时间
                // console.log(end)
                let result = parseInt((end - startTime) / 1000); //计算出豪秒
                let d = parseInt(result / (24 * 60 * 60)); //用总共的秒数除以1天的秒数
                let h = parseInt((result / (60 * 60)) % 24); //精确小时，用去余
                let m = parseInt((result / 60) % 60); //剩余分钟就是用1小时等于60分钟进行趣余
                let s = parseInt(result % 60);
                //当倒计时结束时，改变内容
                if (result <= 0) {
                    return 0
                }
                if (h < 10) {
                    h = "0" + h
                }
                if (m < 10) {
                    m = "0" + m
                }
                if (s < 10) {
                    s = "0" + s
                }
                if (h == 0 && m == 0) {
                    return s + "s"
                } else if (h == 0) {
                    return m + ":" + s
                } else if (d == 0) {
                    return h + ":" + m + ":" + s
                } else {
                    if(d > 1){
                        return d + this.$t('account.days') + h + ":" + m + ":" + s
                    }else{
                        return d + this.$t('account.day') + h + ":" + m + ":" + s
                    }
                }
            },

            // 定时器
            countDown() {
                let that = this;
                that.countDownFn = setInterval(() => {
                    //  console.log(that.countDownFun(item.nextWithdrawalTime))
                    let html = that.countDownFun(that.countDownTime)
                    if (html === 0) {
                        that.nextWithdrawalTime = ''
                        clearInterval(that.countDownFn); //清除定时器
                    } else {
                        that.countDownTime = that.countDownFun(that.nextWithdrawalTime)
                    }
                }, 1000)
            },
            returnpage() {
                this.$router.go(-1)
            },
            submitForm(formName) {
                let that = this
                if(that.nextWithdrawalTime){
                    this.$message.error(this.$t('account.no_next_withdrawal_time'))
                    return
                }
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        do_withdraw(this.ruleForm).then(res => {
                            if (res.code == 1) {
                                this.$message.success(res.msg)
                                this.getList()
                                this.ruleForm.money = ""
                                this.ruleForm.walletAddress = ""
                                this.ruleForm.payPassword = ""
                            } else {
                                this.$message.error(res.msg)
                            }

                        }).catch(_ => {

                        });
                    } else {
                        return false;
                    }
                });
            },
            handleSuccess() {

            },
            handleRemove() {

            }
        }
    }
</script>
<style lang="scss" scoped>
    .cash {
        font-size: 18px;

        .selebox {
            width: 100%;
        }

        .lctitbox {
            background: rgb(36, 36, 36);
            padding: 10px;
            font-size: 16px;
            box-sizing: border-box;
            border-radius: 10px;

            .fontw {
                line-height: 40px;
                font-size: 20px;
                font-weight: bold;
            }

            img {
                width: 80px;
                height: 80px;
                padding-right: 30px;
            }
        }

        .accctit {
            font-size: 24px;
            font-weight: bold;
            line-height: 80px;
        }
        .nextcash{
          float: right;
        }

        .lctitbox {
            background: rgb(36, 36, 36);
            padding: 10px;
            font-size: 16px;
            box-sizing: border-box;
            border-radius: 10px;
            margin-top: 10px;
            .fontw {
                line-height: 40px;
                font-size: 20px;
                font-weight: bold;
            }

            img {
                width: 80px;
                height: 80px;
                padding-right: 30px;
            }
        }

        .accctit {
            font-size: 24px;
            font-weight: bold;
            line-height: 80px;
        }

        .tiplin {
            line-height: 40px;
        }

        .marr {
            text-align: center;
            line-height: 26px;

            img {
                width: 200px;
                height: 200px;
                margin-right: 30px;
            }
        }

        .gzimgbox {
            width: 60%;
            margin: 20px auto;
        }

        .examplelistbox {
            img {
                width: 300px;
                height: 600px;
            }
        }

        .sylistbox {
            .tablet {
                width: 100%;
                background: #3a3a3a;

                & > div {
                    width: 33.2%;
                    height: 50px;
                    border: 1px solid #5c5c5c;
                    line-height: 50px;
                    font-size: 18px;


                }

                &.itemvue {
                    border: 0px;
                    color: #fff;
                    background: #3a3a3a;

                    & > div {
                        border: 0px;
                        color: #fff;
                    }

                }
            }

            .srollbox {
                height: 380px;
                background: #3a3a3a;
                overflow: hidden;
            }
        }

        .examplebox {
            padding: 30px 0px;
        }

        .formbox {
            width: 60%;
            margin: 30px auto;
            padding: 30px;
            border-radius: 20px;
            border: 1px solid rgb(85, 85, 85);

            .bgb {
                margin: 40px 0px 20px 0px;
                padding: 14px 30px;
                background: #1750cc;
                color: #fff;
                font-size: 20px;
            }
        }
    }
</style>
